module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.state) ? _c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        _vm.sendActivate()
      }
    }
  }, [_vm._v("\n  Activer\n")]) : _c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        _vm.sendDeactivate()
      }
    }
  }, [_vm._v("\n  Désactiver\n")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-755109be!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/ActivateDeactivateButton.vue
// module id = 1876
// module chunks = 2